import { h, Fragment } from "preact";
import ProductOptionSwatch from "./product-option-swatch";
import sanitizeOptionValue from "../../helpers/sanitizeOptionValue";

export default function ProductOptionSwatches({
  optionValues,
  optionName,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues = [],
}) {
  return (
    <div className="product-options__swatches">
      <div className="product-options__name">{optionName}</div>
      <div className="product-options__selected-value">
        {sanitizeOptionValue(selectedOptionValue)}
      </div>
      <div className="product-options__swatch-list">
        {optionValues.map((optionValue) => (
          <ProductOptionSwatch
            key={optionValue.name}
            optionValue={optionValue}
            optionName={optionName}
            disabled={disabledOptionValues.includes(optionValue.name)}
            updateOptionValue={updateOptionValue}
            selected={optionValue.name === selectedOptionValue}
          />
        ))}
      </div>
    </div>
  );
}
